const initialState = {
    sow: {},
    answers: {},

    updating: false,
    updated: false,
    error: null
}

export function sowReducer(state = initialState, action) {

    switch (action.type) {

        case "CREATE_SOW":
        case "FETCH_SOW":
        case "FETCH_SOW_ANSWERS":
        case "UPDATE_SOW": {
            return { ...state, updating: true, updated: false, error: null }
        }

        case "CREATE_SOW_REJECTED":
        case "FETCH_SOW_REJECTED":
        case "FETCH_SOW_ANSWERS_REJECTED":
        case "UPDATE_SOW_REJECTED": {
            return { ...state, updating: false, error: action.payload }
        }

        case "CREATE_SOW_FULFILLED":
        case "FETCH_SOW_FULFILLED":
        case "UPDATE_SOW_FULFILLED": {
            return { ...state, updating: false, updated: true, sow: action.payload.data }
        }

        case "FETCH_SOW_ANSWERS_FULFILLED": {
            var answers = Object.assign({}, action.payload.data)

            answers.projectTabs = answers.projectTabs.filter((answer) => { return answer.active && !answer.deleted })

            return { ...state, updating: false, updated: true, answers: answers }
        }

        case "SOW_ERROR": {
            return { ...state, error: null }
        }

        default:
            return state
    }
}